<div class={$$props.class} id="home">
  <div id="introduction">
    hello, my name is
    <div id="name">tommy huang.</div>
  </div>
</div>

<style>
  #home {
    transform: translateX(-20%);
  }
  #introduction {
    font-size: 3.5vw;
    margin-left: 15vmin;
  }
  #name {
    font-size: 80px;
    font-size: 6vw;
  }
</style>
